import type React from "react";
import { useAudienceModalContext } from "../../providers/AudienceModalContext";

export interface AudienceModalBodyProps {
	children: React.ReactNode;
}

const AudienceModalBody: React.FC<AudienceModalBodyProps> = ({ children }) => {
	const { step } = useAudienceModalContext();

	return <div className={`audience-modal-body step-${step}`}>{children}</div>;
};

export default AudienceModalBody;
